export default __webpack_public_path__ + "static/media/background_2_large.0d0009bb.jpg";